export const selectOptionsExceptionCategory = [
  "Subject Property",
  "Borrower",
  "Existing Mortgage History",
  "Borrower Exposure",
  "Appraisal",
  "Title",
  "Entity",
  "Other",
  "Closing Process",
  "Pricing",
  "Leverage",
  // Backs a loan-level borrower_classification_override (backend 2026-10-01).
  "Borrower Classification",
];
